<app-ace-select
  #aceSelect
  bindLabel="name"
  [items]="options"
  [placeholder]="placeholder | messageTranslate"
  [loading]="loading"
  [hideSelected]="hideSelected"
  [multiSelect]="true"
  [appendTo]="appendTo"
  [clearable]="false">

  <ng-template #optionTemplate #labelTemplate let-measure="item">
    <span class="ng-value-label">{{measure.name | messageTranslate}}</span>
  </ng-template>

</app-ace-select>
